import { useMutation } from '@tanstack/react-query';
import {
  upsertBusinessDetails,
  UpsertBusinessDetailsRequest,
  BusinessDetailsResponse,
} from '../api/businessDetailsApi';

/**
 * Mutation hook for saving business details.
 *
 * Errors are handled by the global QueryClient onError (shows snackbar).
 * Callers can override with mutate(data, { onSuccess, onError }).
 */
export function useBusinessDetailsCapture() {
  return useMutation({
    mutationFn: (
      request: UpsertBusinessDetailsRequest
    ): Promise<BusinessDetailsResponse> => upsertBusinessDetails(request),
  });
}
